<template>
    <div>
        <div class="support-box">
            <CompCharts class="charts" :option="state.option" />
            <div class="title">筹款金额 ￥{{ tools.fmoney(props.backer_money) }}</div>
        </div>
    </div>
</template>

<script setup>
import * as echarts from 'echarts';
import tools from '@/utils/tools.js'
import CompCharts from "../analysis/charts.vue";
import { reactive, computed, defineProps } from "vue";
const props = defineProps({
    riqi: Array,
    all_money: Array,
    goal: String,
    backer_money: String
})
const state = reactive({
    tooltip: {
        trigger: 'axis',
    },
    color: ['#00C4A1'],
})
state.markLine = computed(() => {
    if(props.goal) {
        return {
            silent: false,
            symbol: 'none',
            label: {
                show: false
            },
            data: [
                {
                    yAxis: props.goal,
                    lineStyle: {
                        type: 'solid',
                        color: 'rgba(0, 196, 161, 0.2)',
                        width: '2'
                    }
                },
            ]
        }
    } else {
        return {}
    }
})
state.option = computed(() => {
    return {
        tooltip: state.tooltip,
        color: state.color,
        grid: {
            show: true,
            shadowColor: '#00C4A1'
        },
        xAxis: {
            data: props.riqi
        },
        yAxis: {},
        series: [
            {
                name: '筹款金额',
                type: 'line',
                showSymbol: false,
                markLine: state.markLine,
                areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                            offset: 0,
                            color: 'rgba(0, 196, 161, 0.2)'
                        },
                        {
                            offset: 1,
                            color: 'rgba(0, 196, 161, 0)'
                        }
                        ])
                },
                data:  props.all_money,
            }
        ]
    }
})
</script>

<style lang="scss" scoped>
.support-box {
    width: 100%;
    padding-top: 80%;
    position: relative;
    .charts {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }
    .title {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 16px;
        display: flex;
        align-items: center;
        .icon {
            margin-left: 5px;
        }
    }
}
</style>
